/* eslint class-methods-use-this:0 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import InfosMobile from '../infos_mobile/InfosMobile';

import './Searchbar.css';

import { setQuotationParams, cleanComparisonPlans, filterPlansMobile } from '../../../actions/searchActions';

import Frame from '../../../lib/sp_frame';

import { formatURL, cleanDate, showDateVerbose, formatDate } from '../../../utils';

const addClass = (el, className) => {
  el.classList.add(className);
};

const rmClass = (el, className) => {
  el.classList.remove(className);
};

const addAttr = (el, attrName, attrValue) => {
  el.setAttribute(attrName, attrValue);
};

const rmAttr = (el, attrName) => {
  el.removeAttribute(attrName);
};

const init = (component, initialValues) => {
  const destinationInput = document.querySelector('#destinationSp');
  const departureDateInput = document.querySelector('#departureDateInput');
  const departureDateContainer = document.querySelector('#departureDateContainer');
  const returningDateInput = document.querySelector('#returningDateInput');
  const returningDateContainer = document.querySelector('#returningDateContainer');
  const mobile = window.innerWidth <= 800;

  const destination = new Frame.Destination({
    initialValue: initialValues.destination,
    input: destinationInput,
    onError: {
      INVALID_VALUE: () => {
        addClass(destinationInput, 'is-danger');
      },
    },
    onChange: () => {
      rmClass(destinationInput, 'is-danger');
      component.handleChange({ target: { name: 'destination', value: destination.getSelected().slug } });
    },
  });
  const departureDate = new Frame.Period({
    input: departureDateInput,
    dateContainer: departureDateContainer,
    container: document.getElementById('ex-input-departure'),
    multipleCalendars: true,
    startDatePicker: true,
    onShow(frame, drop) {
      addClass(departureDateContainer, 'ex-inputs-picker-visible');
      drop === 'up'
        ? addClass(departureDateContainer, 'ex-inputs-picker-up')
        : rmClass(departureDateContainer, 'ex-inputs-picker-up');
      if (window.innerWidth <= 640) {
        addClass(document.querySelector('html'), 'overflow-hidden');
        addClass(document.querySelector('body'), 'overflow-hidden');
      }
    },
    onChange() {
      rmClass(departureDateInput, 'is-danger');
    },
    onError: {
      INVALID_VALUE(Frame) {
        departureDateInput.value = '';
        component.handleChange({ target: { name: 'begin_date', value: '' } });
        addClass(departureDateInput, 'is-danger');
      },
    },
    onHide(Frame) {
      if (window.innerWidth <= 640) {
        rmClass(document.querySelector('html'), 'overflow-hidden');
        rmClass(document.querySelector('body'), 'overflow-hidden');
      }
      rmClass(departureDateContainer, 'ex-inputs-picker-visible');
      rmClass(departureDateContainer, 'ex-inputs-picker-up');
    },
    onSelect(Frame) {
      if (frame.departureDate.datePicker.state.start) {
        component.handleChange({
          target: { name: 'begin_date', value: Frame.departureDate.datePicker.state.start.toPtBr() },
        });
        this.input.value = mobile
          ? Frame.departureDate.datePicker.state.start.toPtBr()
          : showDateVerbose(Frame.departureDate.datePicker.state.start.toPtBr());

        frame.returningDate.validate();
      }
    },
  });

  const returningDate = new Frame.Period({
    input: returningDateInput,
    dateContainer: returningDateContainer,
    container: document.getElementById('ex-input-return'),
    multipleCalendars: true,
    startDatePicker: false,
    onShow(frame, drop) {
      if (window.innerWidth <= 640) {
        addClass(document.querySelector('html'), 'overflow-hidden');
        addClass(document.querySelector('body'), 'overflow-hidden');
      }
      addClass(returningDateContainer, 'ex-inputs-picker-visible');
      drop === 'up'
        ? addClass(returningDateContainer, 'ex-inputs-picker-up')
        : rmClass(returningDateContainer, 'ex-inputs-picker-up');
    },
    onChange(Frame) {
      rmClass(returningDateInput, 'is-danger');
    },
    onError: {
      INVALID_VALUE(Frame) {
        returningDateInput.value = '';
        component.handleChange({ target: { name: 'end_date', value: '' } });
        addClass(returningDateInput, 'is-danger');
      },
    },
    onHide(Frame) {
      if (window.innerWidth <= 640) {
        rmClass(document.querySelector('html'), 'overflow-hidden');
        rmClass(document.querySelector('body'), 'overflow-hidden');
      }
      rmClass(returningDateContainer, 'ex-inputs-picker-visible');
      rmClass(returningDateContainer, 'ex-inputs-picker-up');
    },
    onDisable() {
      addAttr(returningDateInput, 'disabled', 'disabled');
    },
    onEnable() {
      rmAttr(returningDateInput, 'disabled');
    },
    onSelect(Frame) {
      if (frame.returningDate.datePicker.state.end) {
        component.handleChange({
          target: { name: 'end_date', value: Frame.returningDate.datePicker.state.end.toPtBr() },
        });
        this.input.value = mobile
          ? Frame.returningDate.datePicker.state.end.toPtBr()
          : showDateVerbose(Frame.returningDate.datePicker.state.end.toPtBr());
      }
    },
  });
  let frame = new Frame.Frame({
    destination,
    departureDate,
    returningDate,
    client: false,
    openInNewTab: false,
  });

  const beginDate = new Date(
    parseInt(initialValues.begin_date.split('/')[2], 0),
    parseInt(initialValues.begin_date.split('/')[1], 0) - 1,
    parseInt(initialValues.begin_date.split('/')[0], 0)
  );
  const endDate = new Date(
    parseInt(initialValues.end_date.split('/')[2], 0),
    parseInt(initialValues.end_date.split('/')[1], 0) - 1,
    parseInt(initialValues.end_date.split('/')[0], 0)
  );

  frame.departureDate.setStartDate(beginDate);
  frame.returningDate.setStartDate(beginDate);
  frame.departureDate.setEndDate(endDate);
  frame.returningDate.setEndDate(endDate);
};

class SearchBarMobile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      destination: props.match.params.destination || '',
      begin_date: cleanDate(props.match.params.begin_date) || '',
      end_date: cleanDate(props.match.params.end_date) || '',
      infoStyle: {},
      searchbarStyle: { display: 'none' },
      destinations: props.destinations || [],
    };
    this.init = init.bind(this);
    this.searchPlan = this.searchPlan.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.setQuotationParams = this.props.setQuotationParams.bind(this);
  }
  componentDidMount() {
    this.init(this, {
      destination: this.getDestinationDisplay(this.state.destination),
      begin_date: this.formatDate(this.state.begin_date),
      end_date: this.formatDate(this.state.end_date),
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.destinations !== this.props.destinations) {
      this.setState({ destinations: this.props.destinations });
    }
  }

  getDestinationDisplay(slug) {
    if (!this.state.destinations.length) return '';

    const display = this.state.destinations.filter((destination) => destination.slug === slug);
    if (!display.length) return '';

    return display[0].name;
  }

  formatDate(date) {
    const spl = date.match(/(\d{4})-(\d{2})-(\d{2})/);
    if (!spl) return '';

    return `${spl[3]}/${spl[2]}/${spl[1]}`;
  }

  searchPlan() {
    if (this.formatDate(this.state.begin_date) !== '' && this.formatDate(this.state.end_date) !== '') {
      this.props.cleanComparisonPlans();
      this.props.filterPlansMobile();
      const path = formatURL(
        this.props.match.params,
        `/pesquisa/${this.state.destination}/${this.state.begin_date}/${this.state.end_date}`
      );
      this.props.history.push(path);
    }
  }

  handleChange(e) {
    if (e.target.name === 'begin_date' || e.target.name === 'end_date') {
      const splDate = e.target.value.split('/');
      const val = `${splDate[2]}-${splDate[1]}-${splDate[0]}`;
      e.target.value = val;
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    return (
      <div className={`component search-mobile ${this.props.searchState && 'open'}`}>
        <section className="search-mobile-plans">
          <InfosMobile destinations={this.props.destinations} />
          <div className="text-searchbar">Editar pesquisa</div>
          <form id="date_container">
            <div htmlFor="continente" className="group">
              <label htmlFor="destiny" className="label-content label-destiny" data-title="Destino">
                <input
                  id="destinationSp"
                  className="control destiny"
                  type="text"
                  name="destination"
                  value={this.getDestinationDisplay(this.state.destination) || ''}
                  readOnly
                  data-cy="search-frame-destino"
                />
              </label>
            </div>

            <div className='group-ex-input-departure-return-mobile'>
            <div id="ex-input-departure" className="ex-inputs group">
              <label htmlFor="departureDateInput" className="label-content" data-title="Partida">
                <input
                  className="control go"
                  name="departureDate"
                  value={formatDate(this.state.begin_date) || 'Ida'}
                  type="text"
                  id="departureDateInput"
                  readOnly
                  data-cy="search-frame-partida"
                />
              </label>
              <div id="departureDateContainer" className="ex-inputs-picker"></div>
            </div>

            <div id="ex-input-return" className="ex-inputs group">
              <label htmlFor="returningDateInput" className="label-content" data-title="Retorno">
                <input
                  className="control return last-back"
                  name="returningDate"
                  value={formatDate(this.state.end_date) || ''}
                  type="text"
                  id="returningDateInput"
                  readOnly
                  data-cy="search-frame-retorno"
                />
              </label>
              <div id="returningDateContainer" className="ex-inputs-picker"></div>
            </div>
            </div>

            <div className="input-submit" data-cy="search-frame-mobile-pesquisar">
              <input
                type="button"
                name="submit"
                value="Atualizar pesquisa"
                className="control update"
                id="searchBtn"
                onClick={this.searchPlan}
              />
            </div>
          </form>
        </section>
      </div>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      searchState: state.search.searchState,
      destinations: state.global.destinations,
    }),
    {
      setQuotationParams,
      cleanComparisonPlans,
      filterPlansMobile,
    }
  )(SearchBarMobile)
);



// WEBPACK FOOTER //
// ./src/components/search/searchbar/SearchBarMobile.jsx